import { combineReducers } from 'redux';
import furniture from 'containers/Configurator/reducers/furniture';
import pieces from 'containers/Configurator/reducers/pieces';
import colors from 'containers/Configurator/reducers/colors';
import rules from 'containers/Configurator/reducers/rules';
import selection from 'containers/Configurator/reducers/selection';
import general from 'containers/Configurator/reducers/general';
import history from './history';

export default combineReducers({
  furniture,
  pieces,
  colors,
  rules,
  selection,
  general,
  history,
});
